export const integrationKeysProps = [
  {
    id: 'minus',
    label: '-',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '-',
      method: 'write',
    },
    group: 'basicOperations',
  },
  {
    id: 'times',
    label: '\\times',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\times',
      method: 'cmd',
    },
    group: 'basicOperations',
  },
  {
    id: 'frac',
    label: '\\div',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '/',
      method: 'cmd',
    },
    group: 'basicOperations',
  },
  {
    id: '&#8730',
    label: '\\sqrt',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\sqrt',
      method: 'cmd',
    },
    group: 'basicOperations',
  },
  {
    id: 'square',
    label: '\\square^2',
    labelType: 'tex',
    group: 'basicOperations',
    mathfieldInstructions: { content: '^2', method: 'write' },
  },

  {
    id: 'cube',
    label: '\\square^3',
    labelType: 'tex',

    mathfieldInstructions: { content: '^3 ', method: 'write' },
    group: 'otherOperations',
  },
  {
    id: 'power',
    label: '\\square^n',
    labelType: 'tex',
    group: 'basicOperations',

    mathfieldInstructions: { content: '^', method: 'cmd' },
  },
  {
    id: 'leftParenthesis',
    label: '(',
    labelType: 'tex',
    group: 'basicOperations',

    mathfieldInstructions: {
      content: '(',
      method: 'typedText',
    },
  },
  {
    id: 'rightParenthesis',
    label: ')',
    labelType: 'tex',
    group: 'basicOperations',

    mathfieldInstructions: {
      content: ')',
      method: 'typedText',
    },
  },

  {
    id: 'comma',
    label: '{,}',
    labelType: 'tex',
    group: 'basicOperations',

    mathfieldInstructions: {
      content: ',',
      method: 'write',
    },
  },
  {
    id: 'dot',
    label: '.',
    labelType: 'tex',
    group: 'basicOperations',

    mathfieldInstructions: {
      content: '.',
      method: 'write',
    },
  },
  {
    id: 'obelus',
    label: '\\div',
    labelType: 'tex',
    group: 'basicOperations',

    mathfieldInstructions: {
      content: '\\div',
      method: 'write',
    },
  },
  {
    id: '%',
    label: '\\%',
    labelType: 'tex',
    group: 'otherOperations',

    mathfieldInstructions: {
      content: '%',
      method: 'write',
    },
  },
  {
    id: '(□)',
    label: '\\left({}\\right)',
    labelType: 'tex',
    group: 'otherOperations',

    mathfieldInstructions: {
      content: '\\left({}\\right)',
      method: 'write',
    },
  },
  {
    id: 's6',
    label: '\\left\\{{}\\right\\}',
    // label: '\\binom{}{}',
    labelType: 'tex',
    group: 'otherOperations',

    mathfieldInstructions: {
      content: '\\left\\{{}\\right\\}',
      // content: '\\binom{}{}',1
      method: 'write',
    },
  },
  // {
  //   id: 'I1',
  //   label: '\\oint',
  //   labelType: 'tex',

  //   mathfieldInstructions: {
  //     content: '\\oint',
  //     method: 'write',
  //   },
  //   group: 'integration',
  // },
  {
    id: 'I10',
    label: '\\oint',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\oint',
      method: 'write',
    },
    group: 'integration',
  },

  {
    id: 'I12',
    label: '\\oint\\_{}^{}',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\oint\\_{}^{}',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I13',
    label: '\\pointint[_0^1]',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\pointint[_0^1]',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I2',
    label: '\\iint',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\iint',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I1',
    label: '\\int',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\int',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I3',
    label: '\\int_{}^{}',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\int_{}^{}',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I4',
    label: '\\int\\int',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\int\\int',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I19',
    label: '\\left\\{{}\\right\\}',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\left\\{{}\\right\\}',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I20',
    label: '\\left(\\left(\\right),\\left(\\right)\\right)',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\left(\\left(\\right),\\left(\\right)\\right)',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I21',
    label: '\\left(\\frac{ }{ }\\right)',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\left(\\frac{ }{ }\\right)',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I22',
    label: '\\pi',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\pi',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I23',
    label: '\\leq',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\leq',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I24',
    label: '\\geq',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '\\geq',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I25',
    label: '<',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '<',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I26',
    label: '>',
    labelType: 'tex',

    mathfieldInstructions: {
      content: '>',
      method: 'write',
    },
    group: 'integration',
  },
  {
    id: 'I27',
    label: '\\ne',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\ne',
      method: 'write',
    },
    group: 'geometry',
  },
]
